import { ISegmentParticipants } from '@features/add-participants-modal';

export const generateNumericId = (): number => {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1000);
  const full = `${timestamp}${random}`;
  return Number(full.slice(-9));
};

export const createInitialSegment = (): ISegmentParticipants => ({
  id: generateNumericId(),
  eventId: 0,
  title: 'Название сегмента',
  countTicket: 0,
  companiesStructureList: {},
  freelanceEmployee: [],
});
